/* 绑定手机号 */
<template>
  <div class="binding-phone-box">
    <div class="content">
      <verification
        title="请绑定手机号"
        agreementText="绑定即代表同意"
        btnName="立即绑定"
        smsType="3"
        @callSubmit="submit"
      ></verification>
    </div>
  </div>
</template>

<script>
import verification from "@/components/login/verification.vue";
import userApi from "@/api/userApi";
import { setToken, setUserId } from "@/libs/util";

export default {
  data() {
    return {
      bindToken: ""
    };
  },
  mounted() {
    this.bindToken = this.$route.query.bindToken;
    console.log('5555', this.bindToken)
  },
  components: {
    verification
  },
  methods: {
    submit(phone, smsCode) {
      let data = {
        bind_token: this.bindToken,
        phone: phone,
        send_code: smsCode
      };
      userApi.bind(data).then(res => {
        if (res.user_id != undefined) {
          setUserId(res.user_id);
          setToken(res.token);
          this.$store.commit("setUserObj", {
            phone: res.phone,
            open_id: res.open_id,
            user_id: res.user_id,
            user_level: res.user_level,
            user_type: res.user_type,
            invitation_code: res.invitation_code
          });

          this.$router.push({
            name: "myUserHome"
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>
